module.exports = __webpack_public_path__ + "img/portrait-045.4a19ab1e.jpg";